<template>
  <b-container class="mt-4 h-95">
    <b-row class="h-100">
      <b-col class="d-flex flex-column">
        <b-row>
          <b-col class="h3">Registro de Entrada no Refeitório</b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form>
              <Fieldset
                legend="Filtros"
                :toggleable="true"
                class="px-3 pb-3"
                ref="fieldset"
              >
                <b-row>
                  <b-col>
                    <label for="data">Data</label>
                    <b-form-datepicker
                      id="data"
                      v-model="data"
                      :state="!$v.data.$error ? null : false"
                    ></b-form-datepicker>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group
                      id="tipo-autorizacao-fg"
                      label="Tipo de autorização"
                      label-for="tipo-autorizacao"
                    >
                      <b-form-select
                        id="tipo-autorizacao"
                        name="tipo-autorizacao"
                        v-model="tipoautorizacao"
                        :state="$v.tipoautorizacao.$error ? false : null"
                        class="mb-3"
                      >
                        <template v-slot:first>
                          <b-form-select-option :value="null" disabled
                            >-- Selecione o tipo de autorização
                            --</b-form-select-option
                          >
                        </template>
                        <b-form-select-option
                          v-for="tipoautorizacao in tiposautorizacoes"
                          :key="tipoautorizacao.id"
                          :value="tipoautorizacao"
                          >{{ tipoautorizacao.descricao }}</b-form-select-option
                        >
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group
                      id="tipo-refeicao-fg"
                      label="Tipo de refeição"
                      label-for="tipo-refeicao"
                    >
                      <b-form-select
                        id="tipo-refeicao"
                        name="tipo-refeicao"
                        v-model="tiporefeicao"
                        :state="$v.tiporefeicao.$error ? false : null"
                        class="mb-3"
                      >
                        <template v-slot:first>
                          <b-form-select-option :value="null" disabled
                            >-- Selecione o tipo de refeição
                            --</b-form-select-option
                          >
                        </template>
                        <b-form-select-option
                          v-for="tiporefeicao in tiposrefeicoes"
                          :key="tiporefeicao.id"
                          :value="tiporefeicao"
                          >{{ tiporefeicao.descricao }}</b-form-select-option
                        >
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>
              </Fieldset>
              <b-row class="mt-2">
                <b-col>
                  <b-button variant="success" @click="geraRelatorio"
                    >Gerar relatório</b-button
                  >
                </b-col>
              </b-row>
            </b-form>
          </b-col>
        </b-row>

        <b-row class="mt-2 flex-grow-1 h-100" v-show="isDisplayingReport">
          <b-col>
            <embed
              :src="src"
              width="100%"
              type="application/pdf"
              height="100%"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Fieldset from "primevue/fieldset";
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      src: "",
      data: null,
      tipoautorizacao: null,
      tiposautorizacoes: [],
      tiporefeicao: null,
      tiposrefeicoes: [],
      isDisplayingReport: false,
    };
  },
  components: {
    Fieldset,
  },
  methods: {
    geraRelatorio() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$refs.fieldset.toggle();
        this.$http({
          url: `/registroentrada?data=${this.data}&tipoautorizacao=${this.tipoautorizacao.id}&tiporefeicao=${this.tiporefeicao.id}`,
          responseType: "blob",
        }).then((response) => {
          var blob = new Blob([response.data], {
            type: "application/pdf",
          });
          var url = window.URL.createObjectURL(blob);
          this.src = url;
        });

        this.isDisplayingReport = true;
      }
    },
    getTiposAutorizacoes() {
      this.$http.get("/tipoautorizacao").then((response) => {
        this.tiposautorizacoes = response.data;
      });
    },
    getTiposRefeicoes() {
      this.$http.get("/tipoderefeicao").then((response) => {
        this.tiposrefeicoes = response.data;
      });
    },
  },
  validations: {
    tipoautorizacao: {
      required,
    },
    data: {
      required,
    },
    tiporefeicao: {
      required,
    },
  },
  mounted() {
    this.getTiposAutorizacoes();
    this.getTiposRefeicoes();
  },
};
</script>

<style strict>
.p-fieldset-legend {
  width: auto !important;
  font-size: 1rem !important;
}
.h-90 {
  height: 90%;
}
.h-95 {
  height: 95%;
}
</style>
